// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"d6fdf0fb","2682":"930df20d","4565":"f51d23bb","9103":"b9ea4917"}[chunkId] + ".css";
};